import getConfig from 'next/config';

const {
  publicRuntimeConfig: { runtimeEnv },
} = getConfig();

export default runtimeEnv === 'production';
